const PLAYLIST = [
  {
    episode: 1,
    videoId: "CTRvs6bW6CQ",
    title: "中华道路",
    translatedTitle: "Chinese Road (Note: This episode features embedded subtitles released by the publisher)",
    thumbnail: "https://i.ytimg.com/vi/CTRvs6bW6CQ/default.jpg",
  },
  {
    episode: 2,
    videoId: "bM77ikvvRtc",
    title: "中华先祖",
    translatedTitle: "Chinese Ancestor",
    thumbnail: "https://i.ytimg.com/vi/bM77ikvvRtc/default.jpg",
  },
  {
    episode: 3,
    videoId: "b6lKvQfHGq0",
    title: "农业起源",
    translatedTitle: "Agricultural Origin",
    thumbnail: "https://i.ytimg.com/vi/b6lKvQfHGq0/default.jpg",
  },
  {
    episode: 4,
    videoId: "2TxucSA0v9M",
    title: "文明起源",
    translatedTitle: "The Origin of Civilization",
    thumbnail: "https://i.ytimg.com/vi/2TxucSA0v9M/default.jpg",
  },
  {
    episode: 5,
    videoId: "6s9JziziLtM",
    title: "邦国时代",
    translatedTitle: "Bangguo Era",
    thumbnail: "https://i.ytimg.com/vi/6s9JziziLtM/default.jpg",
  },
  {
    episode: 6,
    videoId: "lS9TUandsI4",
    title: "夏王朝觅踪",
    translatedTitle: "Xia Dynasty Looking for Traces",
    thumbnail: "https://i.ytimg.com/vi/lS9TUandsI4/default.jpg",
  },
  {
    episode: 7,
    videoId: "Lw0fn4eJDG8",
    title: "殷商兴亡",
    translatedTitle: "Yin and Shang Rise and Fall",
    thumbnail: "https://i.ytimg.com/vi/Lw0fn4eJDG8/default.jpg",
  },
  {
    episode: 8,
    videoId: "v5NkwiSa4SU",
    title: "商代文明",
    translatedTitle: "Shang Dynasty Civilization",
    thumbnail: "https://i.ytimg.com/vi/v5NkwiSa4SU/default.jpg",
  },
  {
    episode: 9,
    videoId: "frNNoSOSnm4",
    title: "武王克商",
    translatedTitle: "The King of Wu Reconciles Business",
    thumbnail: "https://i.ytimg.com/vi/frNNoSOSnm4/default.jpg",
  },
  {
    episode: 10,
    videoId: "3oEoKSRNh-Q",
    title: "周公摄政",
    translatedTitle: "Zhou Gong Regent",
    thumbnail: "https://i.ytimg.com/vi/3oEoKSRNh-Q/default.jpg",
  },
  {
    episode: 11,
    videoId: "p0yTTgstVko",
    title: "周王室的衰落",
    translatedTitle: "The Decline of the Zhou Royal Family",
    thumbnail: "https://i.ytimg.com/vi/p0yTTgstVko/default.jpg",
  },
  {
    episode: 12,
    videoId: "eNVssZdWxuM",
    title: "春秋争霸",
    translatedTitle: "Spring and Autumn Hegemony",
    thumbnail: "https://i.ytimg.com/vi/eNVssZdWxuM/default.jpg",
  },
  {
    episode: 13,
    videoId: "FVG8TNux7ls",
    title: "孔子",
    translatedTitle: "Confucius",
    thumbnail: "https://i.ytimg.com/vi/FVG8TNux7ls/default.jpg",
  },
  {
    episode: 14,
    videoId: "YtP58C-ijkI",
    title: "列国变法",
    translatedTitle: "Country Reforms",
    thumbnail: "https://i.ytimg.com/vi/YtP58C-ijkI/default.jpg",
  },
  {
    episode: 15,
    videoId: "Ke9JAY1AfWU",
    title: "战国七雄",
    translatedTitle: "Seven Heroes of the Warring States Period",
    thumbnail: "https://i.ytimg.com/vi/Ke9JAY1AfWU/default.jpg",
  },
  {
    episode: 16,
    videoId: "0NXQ0HhmONA",
    title: "诸子百家",
    translatedTitle: "Philosophers",
    thumbnail: "https://i.ytimg.com/vi/0NXQ0HhmONA/default.jpg",
  },
  {
    episode: 17,
    videoId: "C7pd3y2AvVg",
    title: "秦国崛起",
    translatedTitle: "The Rise of Qin State",
    thumbnail: "https://i.ytimg.com/vi/C7pd3y2AvVg/default.jpg",
  },
  {
    episode: 18,
    videoId: "GVuwVpdgmTU",
    title: "秦始皇统一中国",
    translatedTitle: "Qin Shihuang unified China",
    thumbnail: "https://i.ytimg.com/vi/GVuwVpdgmTU/default.jpg",
  },
  {
    episode: 19,
    videoId: "MSN9NeO9ZYg",
    title: "楚汉战争",
    translatedTitle: "Chu Han War",
    thumbnail: "https://i.ytimg.com/vi/MSN9NeO9ZYg/default.jpg",
  },
  {
    episode: 20,
    videoId: "3UVbpTF3-P4",
    title: "郡国并行",
    translatedTitle: "Countries and Country Parallel",
    thumbnail: "https://i.ytimg.com/vi/3UVbpTF3-P4/default.jpg",
  },
  {
    episode: 21,
    videoId: "0Vc73Bzr0Ao",
    title: "文景之治",
    translatedTitle: "The Rule of Wenjing",
    thumbnail: "https://i.ytimg.com/vi/0Vc73Bzr0Ao/default.jpg",
  },
  {
    episode: 22,
    videoId: "t9TeG6MdbmY",
    title: "汉武帝",
    translatedTitle: "Han Wudi",
    thumbnail: "https://i.ytimg.com/vi/t9TeG6MdbmY/default.jpg",
  },
  {
    episode: 23,
    videoId: "HabJx6fPza0",
    title: "两汉经学",
    translatedTitle: "Two Han Scriptures",
    thumbnail: "https://i.ytimg.com/vi/HabJx6fPza0/default.jpg",
  },
  {
    episode: 24,
    videoId: "HvYs9RisprM",
    title: "昭宣政治",
    translatedTitle: "Zhao Xuan Politics",
    thumbnail: "https://i.ytimg.com/vi/HvYs9RisprM/default.jpg",
  },
  {
    episode: 25,
    videoId: "v8oUalRBZf8",
    title: "王莽改制",
    translatedTitle: "Wang Mang Restructuring",
    thumbnail: "https://i.ytimg.com/vi/v8oUalRBZf8/default.jpg",
  },
  {
    episode: 26,
    videoId: "GjESroGEDTk",
    title: "光武中兴",
    translatedTitle: "Guangwu Zhongxing",
    thumbnail: "https://i.ytimg.com/vi/GjESroGEDTk/default.jpg",
  },
  {
    episode: 27,
    videoId: "UsHB90oSEJc",
    title: "丝绸之路",
    translatedTitle: "Silk Road",
    thumbnail: "https://i.ytimg.com/vi/UsHB90oSEJc/default.jpg",
  },
  {
    episode: 28,
    videoId: "E6eCTlA1fJE",
    title: "清议与党锢",
    translatedTitle: "Clear Discussion and Party Shackle",
    thumbnail: "https://i.ytimg.com/vi/E6eCTlA1fJE/default.jpg",
  },
  {
    episode: 29,
    videoId: "ws0aD05ITKY",
    title: "黄巾起义",
    translatedTitle: "Yellow Turban Uprising",
    thumbnail: "https://i.ytimg.com/vi/ws0aD05ITKY/default.jpg",
  },
  {
    episode: 30,
    videoId: "ounPv4IJVZI",
    title: "三国鼎立",
    translatedTitle: "Three Kingdoms stand together",
    thumbnail: "https://i.ytimg.com/vi/ounPv4IJVZI/default.jpg",
  },
  {
    episode: 31,
    videoId: "B3mCBCLdwPg",
    title: "诸葛亮治蜀",
    translatedTitle: "Zhuge Liang governs Shu",
    thumbnail: "https://i.ytimg.com/vi/B3mCBCLdwPg/default.jpg",
  },
  {
    episode: 32,
    videoId: "Po8ZsvxkMwQ",
    title: "西晋统一",
    translatedTitle: "The Unification of the Western Jin Dynasty",
    thumbnail: "https://i.ytimg.com/vi/Po8ZsvxkMwQ/default.jpg",
  },
  {
    episode: 33,
    videoId: "sO8Z1ZNjwxI",
    title: "魏晋风度",
    translatedTitle: "Wei Jin Style",
    thumbnail: "https://i.ytimg.com/vi/sO8Z1ZNjwxI/default.jpg",
  },
  {
    episode: 34,
    videoId: "uXss-Ni7Alc",
    title: "门阀政治",
    translatedTitle: "Politics of power",
    thumbnail: "https://i.ytimg.com/vi/uXss-Ni7Alc/default.jpg",
  },
  {
    episode: 35,
    videoId: "U9C2EIUg388",
    title: "梁武帝治国",
    translatedTitle: "Liang Wu Emperor Ruled the Country",
    thumbnail: "https://i.ytimg.com/vi/U9C2EIUg388/default.jpg",
  },
  {
    episode: 36,
    videoId: "CsiNs7LVgMA",
    title: "北魏孝文帝改革",
    translatedTitle: "Reform by Emperor Xiaowen of the Northern Wei Dynasty",
    thumbnail: "https://i.ytimg.com/vi/CsiNs7LVgMA/default.jpg",
  },
  {
    episode: 37,
    videoId: "zQaXM_cUvH4",
    title: "北周武帝",
    translatedTitle: "The Northern Zhou Dynasty Emperor Wu",
    thumbnail: "https://i.ytimg.com/vi/zQaXM_cUvH4/default.jpg",
  },
  {
    episode: 38,
    videoId: "BTcL0tvDvcs",
    title: "陈朝兴亡",
    translatedTitle: "The rise and fall of the Chen Dynasty",
    thumbnail: "https://i.ytimg.com/vi/BTcL0tvDvcs/default.jpg",
  },
  {
    episode: 39,
    videoId: "8Xfsq_epwIo",
    title: "魏晋佛教",
    translatedTitle: "Wei Jin Buddhism",
    thumbnail: "https://i.ytimg.com/vi/8Xfsq_epwIo/default.jpg",
  },
  {
    episode: 40,
    videoId: "BBtL30ikRwo",
    title: "再造统一",
    translatedTitle: "Rebuilding Unity",
    thumbnail: "https://i.ytimg.com/vi/BBtL30ikRwo/default.jpg",
  },
  {
    episode: 41,
    videoId: "sHiXZzk5LmM",
    title: "炀帝功过",
    translatedTitle: "Emperor Yang's merits and demerits",
    thumbnail: "https://i.ytimg.com/vi/sHiXZzk5LmM/default.jpg",
  },
  {
    episode: 42,
    videoId: "rXh_FVYkavg",
    title: "贞观之治",
    translatedTitle: "The Rule of Zhenguan",
    thumbnail: "https://i.ytimg.com/vi/rXh_FVYkavg/default.jpg",
  },
  {
    episode: 43,
    videoId: "mOyC8qdv514",
    title: "武则天",
    translatedTitle: "Wu Zetian",
    thumbnail: "https://i.ytimg.com/vi/mOyC8qdv514/default.jpg",
  },
  {
    episode: 44,
    videoId: "X_2Hbxs_A9s",
    title: "开天盛世",
    translatedTitle: "Opening Heaven and Prosperity",
    thumbnail: "https://i.ytimg.com/vi/X_2Hbxs_A9s/default.jpg",
  },
  {
    episode: 45,
    videoId: "tS95e6Z3nis",
    title: "安史之乱",
    translatedTitle: "Anshi Rebellion",
    thumbnail: "https://i.ytimg.com/vi/tS95e6Z3nis/default.jpg",
  },
  {
    episode: 46,
    videoId: "SgN6rykJEqk",
    title: "中晚唐的困局",
    translatedTitle: "The Dilemma in the Middle and Late Tang Dynasty",
    thumbnail: "https://i.ytimg.com/vi/SgN6rykJEqk/default.jpg",
  },
  {
    episode: 47,
    videoId: "XORQzQd_Mj0",
    title: "世界都会长安",
    translatedTitle: "Changan, the world city",
    thumbnail: "https://i.ytimg.com/vi/XORQzQd_Mj0/default.jpg",
  },
  {
    episode: 48,
    videoId: "u7Jjtm8E4us",
    title: "吐蕃兴衰",
    translatedTitle: "The Rise and Fall of Tubo",
    thumbnail: "https://i.ytimg.com/vi/u7Jjtm8E4us/default.jpg",
  },
  {
    episode: 49,
    videoId: "QYyCL9roSjM",
    title: "敦煌",
    translatedTitle: "Dunhuang",
    thumbnail: "https://i.ytimg.com/vi/QYyCL9roSjM/default.jpg",
  },
  {
    episode: 50,
    videoId: "oJYoRpAx0Ko",
    title: "唐朝的对外关系",
    translatedTitle: "Tang Dynasty's Foreign Relations",
    thumbnail: "https://i.ytimg.com/vi/oJYoRpAx0Ko/default.jpg",
  },
  {
    episode: 51,
    videoId: "0KAhXQoqXTE",
    title: "唐代宗教",
    translatedTitle: "Tang Dynasty Religion",
    thumbnail: "https://i.ytimg.com/vi/0KAhXQoqXTE/default.jpg",
  },
  {
    episode: 52,
    videoId: "K36f_WmoRxc",
    title: "五代十国",
    translatedTitle: "Five Dynasties and Ten Kingdoms",
    thumbnail: "https://i.ytimg.com/vi/K36f_WmoRxc/default.jpg",
  },
  {
    episode: 53,
    videoId: "-O640_JqYeI",
    title: "宋太祖",
    translatedTitle: "Song Taizu",
    thumbnail: "https://i.ytimg.com/vi/-O640_JqYeI/default.jpg",
  },
  {
    episode: 54,
    videoId: "d5vsn7uklfk",
    title: "澶渊之盟",
    translatedTitle: "Chanyuan League",
    thumbnail: "https://i.ytimg.com/vi/d5vsn7uklfk/default.jpg",
  },
  {
    episode: 55,
    videoId: "ItXWyPxEKHs",
    title: "与士大夫共治天下",
    translatedTitle: "To rule the world with scholar-officials",
    thumbnail: "https://i.ytimg.com/vi/ItXWyPxEKHs/default.jpg",
  },
  {
    episode: 56,
    videoId: "cJ5M8JFkzwI",
    title: "王安石变法",
    translatedTitle: "Wang Anshi Reform",
    thumbnail: "https://i.ytimg.com/vi/cJ5M8JFkzwI/default.jpg",
  },
  {
    episode: 57,
    videoId: "915T7Sj7JzQ",
    title: "靖康之难",
    translatedTitle: "Jingkang's Difficulty",
    thumbnail: "https://i.ytimg.com/vi/915T7Sj7JzQ/default.jpg",
  },
  {
    episode: 58,
    videoId: "YykVqbtR6Qo",
    title: "宋金和战",
    translatedTitle: "Song Jin He Zhan",
    thumbnail: "https://i.ytimg.com/vi/YykVqbtR6Qo/default.jpg",
  },
  {
    episode: 59,
    videoId: "GL3LHHM317k",
    title: "偏安东南",
    translatedTitle: "Partial southeast",
    thumbnail: "https://i.ytimg.com/vi/GL3LHHM317k/default.jpg",
  },
  {
    episode: 60,
    videoId: "bBVu4Fc_igE",
    title: "东京梦华",
    translatedTitle: "Tokyo Menghua",
    thumbnail: "https://i.ytimg.com/vi/bBVu4Fc_igE/default.jpg",
  },
  {
    episode: 61,
    videoId: "uB9EI5XCLFQ",
    title: "宋代新儒学",
    translatedTitle: "Song Dynasty Neo-Confucianism",
    thumbnail: "https://i.ytimg.com/vi/uB9EI5XCLFQ/default.jpg",
  },
  {
    episode: 62,
    videoId: "fFI9AEYVSg8",
    title: "宋代文化",
    translatedTitle: "Song Dynasty Culture",
    thumbnail: "https://i.ytimg.com/vi/fFI9AEYVSg8/default.jpg",
  },
  {
    episode: 63,
    videoId: "j4pSqprdOzY",
    title: "契丹兴起",
    translatedTitle: "The Khitan Rise",
    thumbnail: "https://i.ytimg.com/vi/j4pSqprdOzY/default.jpg",
  },
  {
    episode: 64,
    videoId: "bJ-w7TJYAnc",
    title: "西辽建国",
    translatedTitle: "West Liao Jianguo",
    thumbnail: "https://i.ytimg.com/vi/bJ-w7TJYAnc/default.jpg",
  },
  {
    episode: 65,
    videoId: "Qqsfa5ZgC8g",
    title: "完颜阿骨打",
    translatedTitle: "Wan Yan A Gu Da",
    thumbnail: "https://i.ytimg.com/vi/Qqsfa5ZgC8g/default.jpg",
  },
  {
    episode: 66,
    videoId: "BmjgfeOMDjw",
    title: "金朝兴亡",
    translatedTitle: "The Rise and Fall of the Jin Dynasty",
    thumbnail: "https://i.ytimg.com/vi/BmjgfeOMDjw/default.jpg",
  },
  {
    episode: 67,
    videoId: "u5gIS0a9nHE",
    title: "辽金文化",
    translatedTitle: "Liao Jin Culture",
    thumbnail: "https://i.ytimg.com/vi/u5gIS0a9nHE/default.jpg",
  },
  {
    episode: 68,
    videoId: "4jSxBR0PJwA",
    title: "西夏兴亡",
    translatedTitle: "The Rise and Fall of Xixia",
    thumbnail: "https://i.ytimg.com/vi/4jSxBR0PJwA/default.jpg",
  },
  {
    episode: 69,
    videoId: "mbAKh7IV8mo",
    title: "蒙古兴起",
    translatedTitle: "Mongolia Rise",
    thumbnail: "https://i.ytimg.com/vi/mbAKh7IV8mo/default.jpg",
  },
  {
    episode: 70,
    videoId: "ElGtIPOsvvQ",
    title: "忽必烈大帝",
    translatedTitle: "Khublai the Great",
    thumbnail: "https://i.ytimg.com/vi/ElGtIPOsvvQ/default.jpg",
  },
  {
    episode: 71,
    videoId: "sGPUQMy5ELE",
    title: "两都巡幸",
    translatedTitle: "Two Capitals Tour Fortune",
    thumbnail: "https://i.ytimg.com/vi/sGPUQMy5ELE/default.jpg",
  },
  {
    episode: 72,
    videoId: "O1TCG3G4Bec",
    title: "大元帝师八思巴",
    translatedTitle: "The Great Yuan Emperor Master Ba Si Ba",
    thumbnail: "https://i.ytimg.com/vi/O1TCG3G4Bec/default.jpg",
  },
  {
    episode: 73,
    videoId: "oWLKZXBA-L4",
    title: "海上丝绸之路",
    translatedTitle: "Maritime Silk Road",
    thumbnail: "https://i.ytimg.com/vi/oWLKZXBA-L4/default.jpg",
  },
  {
    episode: 74,
    videoId: "1vDBzyjB6Q0",
    title: "马可波罗与中国",
    translatedTitle: "Marco Polo and China",
    thumbnail: "https://i.ytimg.com/vi/1vDBzyjB6Q0/default.jpg",
  },
  {
    episode: 75,
    videoId: "o5wtBLgoKuA",
    title: "元顺帝",
    translatedTitle: "Emperor Yuan Shun",
    thumbnail: "https://i.ytimg.com/vi/o5wtBLgoKuA/default.jpg",
  },
  {
    episode: 76,
    videoId: "w8ob8ElwuCc",
    title: "明太祖朱元璋",
    translatedTitle: "Ming Taizu Zhu Yuanzhang",
    thumbnail: "https://i.ytimg.com/vi/w8ob8ElwuCc/default.jpg",
  },
  {
    episode: 77,
    videoId: "NH2L8kVh6QQ",
    title: "永乐迁都",
    translatedTitle: "Yongle moved the capital",
    thumbnail: "https://i.ytimg.com/vi/NH2L8kVh6QQ/default.jpg",
  },
  {
    episode: 78,
    videoId: "HX8oInOBUvw",
    title: "郑和下西洋",
    translatedTitle: "Zheng He Goes to the West",
    thumbnail: "https://i.ytimg.com/vi/HX8oInOBUvw/default.jpg",
  },
  {
    episode: 79,
    videoId: "IoKEpH-7R1c",
    title: "内阁制度",
    translatedTitle: "Cabinet System",
    thumbnail: "https://i.ytimg.com/vi/IoKEpH-7R1c/default.jpg",
  },
  {
    episode: 80,
    videoId: "B0Orq8x_XC8",
    title: "土木堡之变",
    translatedTitle: "The Change of Tumu Fort",
    thumbnail: "https://i.ytimg.com/vi/B0Orq8x_XC8/default.jpg",
  },
  {
    episode: 81,
    videoId: "6KJun8LaHq0",
    title: "王阳明心学",
    translatedTitle: "Wang Yangming's Heart Study",
    thumbnail: "https://i.ytimg.com/vi/6KJun8LaHq0/default.jpg",
  },
  {
    episode: 82,
    videoId: "X-wfPNr5TsQ",
    title: "海疆与互市",
    translatedTitle: "Sea Territory and Mutual Market",
    thumbnail: "https://i.ytimg.com/vi/X-wfPNr5TsQ/default.jpg",
  },
  {
    episode: 83,
    videoId: "WCPmi4j_GfA",
    title: "张居正改革",
    translatedTitle: "Zhang Juzheng Reform",
    thumbnail: "https://i.ytimg.com/vi/WCPmi4j_GfA/default.jpg",
  },
  {
    episode: 84,
    videoId: "YjhsjtQzBtU",
    title: "耶稣会士来华",
    translatedTitle: "Jesus Coming to China",
    thumbnail: "https://i.ytimg.com/vi/YjhsjtQzBtU/default.jpg",
  },
  {
    episode: 85,
    videoId: "Jkni5T9Pqk0",
    title: "江南市镇",
    translatedTitle: "Jiangnan Town",
    thumbnail: "https://i.ytimg.com/vi/Jkni5T9Pqk0/default.jpg",
  },
  {
    episode: 86,
    videoId: "C3BINyGIn_M",
    title: "白银资本",
    translatedTitle: "Silver Capital",
    thumbnail: "https://i.ytimg.com/vi/C3BINyGIn_M/default.jpg",
  },
  {
    episode: 87,
    videoId: "geLaBIhZ6MU",
    title: "崇祯帝",
    translatedTitle: "The Emperor Chongzhen",
    thumbnail: "https://i.ytimg.com/vi/geLaBIhZ6MU/default.jpg",
  },
  {
    episode: 88,
    videoId: "pCAbKoEB2os",
    title: "入主中原",
    translatedTitle: "Enter the Central Plains",
    thumbnail: "https://i.ytimg.com/vi/pCAbKoEB2os/default.jpg",
  },
  {
    episode: 89,
    videoId: "I4FOw5kYNRU",
    title: "王朝的稳固",
    translatedTitle: "The stability of the dynasty",
    thumbnail: "https://i.ytimg.com/vi/I4FOw5kYNRU/default.jpg",
  },
  {
    episode: 90,
    videoId: "_b3Lys3inZs",
    title: "收复台湾",
    translatedTitle: "Recover Taiwan",
    thumbnail: "https://i.ytimg.com/vi/_b3Lys3inZs/default.jpg",
  },
  {
    episode: 91,
    videoId: "DVVLjg1yFFQ",
    title: "统一大业",
    translatedTitle: "Unification Great Cause",
    thumbnail: "https://i.ytimg.com/vi/DVVLjg1yFFQ/default.jpg",
  },
  {
    episode: 92,
    videoId: "1BLwgRpdB0E",
    title: "军机处",
    translatedTitle: "Military Department",
    thumbnail: "https://i.ytimg.com/vi/1BLwgRpdB0E/default.jpg",
  },
  {
    episode: 93,
    videoId: "djGyjaAYiPI",
    title: "摊丁入庙",
    translatedTitle: "Tan Ding into the temple",
    thumbnail: "https://i.ytimg.com/vi/djGyjaAYiPI/default.jpg",
  },
  {
    episode: 94,
    videoId: "bJyoZLaBQMY",
    title: "文治与文字狱",
    translatedTitle: "Menzhi and Literary Prison",
    thumbnail: "https://i.ytimg.com/vi/bJyoZLaBQMY/default.jpg",
  },
  {
    episode: 95,
    videoId: "gbU3JSanlOI",
    title: "被动的自强",
    translatedTitle: "Passive self-improvement",
    thumbnail: "https://i.ytimg.com/vi/gbU3JSanlOI/default.jpg",
  },
  {
    episode: 96,
    videoId: "e2ZW3rTtZGA",
    title: "鸦片战争",
    translatedTitle: "The Opium War",
    thumbnail: "https://i.ytimg.com/vi/e2ZW3rTtZGA/default.jpg",
  },
  {
    episode: 97,
    videoId: "ia5o9s5BISc",
    title: "太平天国",
    translatedTitle: "Taiping Heavenly Kingdom",
    thumbnail: "https://i.ytimg.com/vi/ia5o9s5BISc/default.jpg",
  },
  {
    episode: 98,
    videoId: "doE20WDYht0",
    title: "甲午战争",
    translatedTitle: "Jiawu War",
    thumbnail: "https://i.ytimg.com/vi/doE20WDYht0/default.jpg",
  },
  {
    episode: 99,
    videoId: "SmK8gpObEjk",
    title: "维新与革命",
    translatedTitle: "Reconstruction and Revolution",
    thumbnail: "https://i.ytimg.com/vi/SmK8gpObEjk/default.jpg",
  },
  {
    episode: 100,
    videoId: "Ui_JaiXxnoc",
    title: "帝制的终结",
    translatedTitle: "The End of Monarchy",
    thumbnail: "https://i.ytimg.com/vi/Ui_JaiXxnoc/default.jpg",
  },
];

export default PLAYLIST;
